//Core modules
import React, {Fragment, useEffect, useState} from "react";

//External modules
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import {Button,
        FormText,
        Input,
        Form,
        FormGroup,
        Label
        } from "reactstrap";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {faCopy} from "@fortawesome/free-solid-svg-icons";
import {Col, Row} from "react-bootstrap";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";

//Internal modules
import ListTable from "./ListTable";
import requestApi from "../services/requestApi.service"
import { getServerDomainURL,handleErrorResponse,showToast } from "./Appcommon";
import Switch from "react-switch";
const TableList = ({onBackAction, adForms, renderElements,webhookform,titlename,listfieldsname,screen,providerDetails,provider,userconfiguration,data}) => {
    let statusFilterOptions = [
		{value: "Basic", label: "Basic"},
		{value: "Advance", label: "Advance"},
        {value: "Preminum", label: "Preminum"},
        {value: "Enterprise", label: "Enterprise"},
	];
        const [copied,setCopied] = useState(false);
    const [apikey, setApikey] = useState({});
    const [phonenumber, setPhonenumber] = useState({});
    const [accesskey, setAccessKey] = useState({});
    const [kplan, setKplan] = useState(statusFilterOptions[0]);
    const [field4, setField4] = useState({});
    const [fields, setFields] = useState({ Web_CTC: false, Mobile_CTC: false, leadcreationstatus: "inactive" });
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    const baseUrl = getServerDomainURL();
    const webhookUrl = baseUrl+"/"+webhookform;
    const [userData,setUserData] = useState([]);

    const { control, handleSubmit, formState: { errors } } = useForm();
    let listFields = listfieldsname;//[['Form ID','Campaign ID','Edit'],['1','2','0']];
    let customFieldConfig = {
        '0' : {
            "render": "editform"
        },
        '-1' : {
            "render": "viewlog"
        },
        '-2' : {
            "render": "deletewebhook"
        },
        '-3' : {
            "render": "pausewebhook"
        }
    };
    useEffect(()=>{
        (async () => {
            if (screen === "CloudTelephony") {
                 await getProviderDetails();
            }
           if(provider === "MyOperator" || provider === "TTS" || provider === "Ozonetel" || provider === "TeleCMI"){
            await getFieldsInfo();
            }
            
        })();
    },[]);   
    const copyUrl = () => {
        setCopied(true);
    }
    const applyFilterOption = async (option, filterName = "") =>{
		 if(filterName == "statusFilter") {
			setKplan(option);
		}
	}
    const chunkedData = [];
    const userConfigData = [];
    try {
        if (screen === "CloudTelephony") {
            for (let i = 0; i < data.length; i += 2) {
                chunkedData.push(data.slice(i, i + 2));
            }
            for (let j = 0; j < userconfiguration.length; j += 2) {
                userConfigData.push(userconfiguration.slice(j, j + 2));
            }
        }
    } catch (error) {
        console.error("An error occurred:", error);
    }

    const getLeadStatus = async (provider) =>{
        let params = {
            "ENTITY" : "CLOUDTELEPHONYLEADSPROCESS",
            "OPERATION" : 'GET_LEADCREATION_STATUS',
            "PROVIDER" : provider,
        }
        let response = await requestApi.processServerRequest(params);
        let data = "";
        if(response.issuccess){
            data = response.data;
        }
        return data;
   }
    const updateProviderDetails = async () => {
        let Status = await getLeadStatus(provider);
        let leadStatus = Status.length > 0 ? Status : 'inactive';
        const providerdetails = [apikey.apikey,apikey.phonenumber,apikey.accesskey,apikey.field_4 !== undefined ? apikey.field_4 : kplan.value,"",{ ...fields, leadcreationstatus: leadStatus }];
        let params = {
            "ENTITY" : "CLOUDTELEPHONYLEADSPROCESS",
            "OPERATION" : "SAVE_CTCPROVIDER_DETAILS",
            "providerdetails" : providerdetails,
            "provider" : provider,
            "USER_FIELDS" : userconfiguration
        }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            showToast(`Saved successfully.`);
            await getProviderDetails();

        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const getProviderDetails = async () => {
        let params = {
            "ENTITY" : "CLOUDTELEPHONYLEADSPROCESS",
            "OPERATION" : "GET_CTCPROVIDER_DETAILS",
            "provider" : provider
        }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
           let tmpInputData ={};
               tmpInputData['apikey'] = response.data[0];
           let tmpInputData2 = {};
               tmpInputData2['phonenumber'] = response.data[1];
           let tmpInputData3 = {};
               tmpInputData3['Access_Key'] = response.data[2];
           let tmpInputData4 = {};
               tmpInputData4['value'] = response.data[3];
               tmpInputData4['label'] = response.data[3];
           let userConfig = response.data[4];
            if (userConfig !== undefined && userConfig !== null && userConfig !='') {
                let parsedData = JSON.parse(userConfig);
                setFields(parsedData);
            } else {
                setFields({ Web_CTC: false, Mobile_CTC: false , leadcreationstatus: "inactive" });
            }
            setApikey(prevApikey => ({
                ...prevApikey,
                apikey: response.data[0],
                phonenumber: response.data[1],
                accesskey: response.data[2],
                field_4:response.data[3],
            }));
            setKplan(tmpInputData4);
        }else{
            handleErrorResponse(response.errormsg);
        }
    }
    
    const handleInputChange = (e, setApikey, key) => {
        const updatedApikey = { ...apikey };
        updatedApikey[key] = e.target.value;
        setApikey(updatedApikey);
    };
    
    const handleFieldChange = async (e,key) => {
        const updatedFields = {...fields,[key]: e,};        
        setFields(updatedFields);
    }
    const getFieldsInfo = async () => {
        if (screen === 'CloudTelephony') {
            let params = {
                "ENTITY": "CLOUDTELEPHONYLEADSPROCESS",
                "OPERATION" : 'USER_FIELDS',
            };
            let response = await requestApi.processServerRequest(params);
            if (response.issuccess) {
                    const userData = response.data.map(option => ({
                        name: option[1],
                        label: option[0]
                    }));                                  
                    setUserData(userData);
            } else {
                handleErrorResponse(response.errormsg);
            }
        }
    };
    const changeCTStatus = async (status, title) => {
        if(title === "Cloud Telephony Web"){
            setFields(prevState => ({
                ...prevState,
                Web_CTC: status
            }));
        }else if(title === "Cloud Telephony Mobile"){
            setFields(prevState => ({
                ...prevState,
                Mobile_CTC: status
            }));
        }
    }

    return (

        <Fragment>
            <div className={`d-flex`}>
                <div className={'cursor-pointer ml-2 mb-2'} onClick={(e) => {onBackAction(e)}}>
                    <FontAwesomeIcon className={`phone-icon`} icon={faArrowLeft}/> Go Back
                </div>
            </div>
            {screen === 'CloudTelephony' ?
            <div className="col-md-8 ctcsetting">
                <div className="ctcsettingname">Provider Details</div>
            <Form onSubmit={handleSubmit(updateProviderDetails)}>
            {chunkedData.map((row, rowIndex) => (
                <FormGroup key={rowIndex}>
                    <Row>
                        {row.map((item, columnIndex) => (
                            <Col key={columnIndex} className="col-sm-6">
                                <Controller
                                    name={item['name']}
                                    control={control}
                                    rules={{ 
                                        required: (((item['field_type'] === 'input' && (apikey[item['key']] === undefined) || apikey[item['key']] === '')) || (item['field_type'] === "select" && JSON.stringify(kplan) === '{}')) 
                                    }}
                                    render={({ field }) => (
                                        <>
                                            <Label for={item['name']}>{item['label']}</Label>
                                            {item['field_type'] === 'input' ? (
                                                <Input
                                                    name={item['name']}
                                                    type={item['type']}
                                                    id={item['name']}
                                                    autoComplete={'on'}
                                                    value={apikey[item['key']] || ''}
                                                    className={`form-control ${errors[item['name']] ? 'is-invalid' : ''}`}
                                                    onChange={(e) => {
                                                        handleInputChange(e, setApikey, item['key']);
                                                        field.onChange(e);
                                                    }}
                                                />
                                            ) : (
                                                <Select
                                                    classNamePrefix="wa-select"
                                                    className={`basic-multi-select ${errors[item['name']] && JSON.stringify(kplan) === '{}' ? 'is-invalid' : ''}`}
                                                    onChange={(e) => {
                                                        applyFilterOption(e, "statusFilter");
                                                    }}
                                                    value={kplan}
                                                    name="status-filter-options"
                                                    id="status-filter-options"
                                                    options={statusFilterOptions}
                                                />
                                            )}
                                         {errors[item['name']] && item['key'] !== "KPlan" ? (
                                            <em className="error invalid-feedback">Please provide {item['label']}</em>
                                        ) : (
                                            errors[item['name']] && JSON.stringify(kplan) === '{}' && (
                                                <em className="error invalid-feedback">Please provide {item['label']}</em>
                                            )
                                        )}
                                        </>
                                    )}
                                />
                            </Col>
                        ))}
                    </Row>
                </FormGroup>
            ))}
                 {userConfigData.length > 0 && (
                <FormGroup>
                    <div className="mb-2 offset-1 col-9">
                        <Label className="ctcaddinfo">User Configuration</Label>
                    </div>
                    {userConfigData.map((row, rowIndex) => (
                        <FormGroup key={rowIndex}>
                            <Row key={rowIndex}>
                                {row.map((config, columnIndex) => ( 
                                    <Col key={columnIndex} className="col-sm-6">
                                        <Label for={config.name}>{config.label}</Label>
                                        <Controller
                                            name={config.name}
                                            control={control}
                                            rules={{ required: fields[config.name] === undefined ? true : false}}
                                            render={({ field }) => (
                                                <Select
                                                {...field}
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                classNamePrefix="wa-select"
                                                className={`basic-multi-select ${errors[config.name] && fields[config.name] === undefined ? 'is-invalid' : ''}`}
                                                options={userData}
                                                value={fields[config.name]}
                                                onChange={e => {
                                                    handleFieldChange(e, config.name);
                                                }}
                                            />
                                            
                                            )}
                                        />
                                        {errors[config.name] && fields[config.name] === undefined  && (
                                            <em className="error invalid-feedback">Please {config.errorMsg}</em>                                        )}
                                    </Col>
                                ))}
                            </Row>
                        </FormGroup>
                    ))}
                </FormGroup>
            )}           
                <div className={"mb-2 offset-1 col-9"}>
                    <Label className="ctcaddinfo"> Additional Configuration</Label>
                </div>
                    <Switch className="webctcleftend"
                        onColor={"#23ae73"}
                        checked={(fields.Web_CTC)}
                        onChange={(status) => changeCTStatus(status, "Cloud Telephony Web")}
                    />
                    <span className="webctcfont webctcleftend">Enable click-to-call in the web app </span>
                    <Switch className="webctcrightend"
                        onColor={"#23ae73"}
                        checked={fields.Mobile_CTC}
                        onChange={(status) => changeCTStatus(status, "Cloud Telephony Mobile")}
                    />
                    <span className="webctcrightend">Enable click-to-call in the mobile app</span>
                    
                <div className="text-center">
                <Button color="success" className={`savebtn`}>
                    Save
                  </Button>
                 </div>
            </Form> 
            </div>:    "" }
            <div className={`${screen === 'CloudTelephony' ? "" : " mb-5" } offset-1 col-10 mt-3 `}>
                <div className={`${screen === 'CloudTelephony' ? "mb-6" : screen === 'webhooks' ? " hide" : " mb-5"} offset-1 col-9`}>
                    <Label className={`${screen === 'CloudTelephony' ? "ctcwebhookname" : "" }`} for="webhookUrl">Webhook URL</Label>
                    <div className={`flex`}>
                        <Input value={webhookUrl} className={`google-ads-webhook-url`} disabled={true} />
                        <CopyToClipboard onCopy={copyUrl} text={webhookUrl}>
                            <Button color="success" className={`google-ads-webhook-copy`}>
                                <FontAwesomeIcon icon={faCopy} />
                            </Button>
                        </CopyToClipboard>
                    </div>
                    {copied ? (
                        <FormText color="success">Text has been copied.</FormText>
                    ) : null}
                </div>
               {(screen !== 'CloudTelephony' ) ? 
                <div className={`offset-4 fb-account-title mb-2`}>
                   {titlename}
                </div> : ""}
                {(screen !== 'CloudTelephony') ? 
                <ListTable
                    key={Math.random()}
                    formData={adForms}
                    fields={listFields}
                    showRowCount={true}
                    spaceBfCell={false}
                    config={customFieldConfig}
                    renderElements={renderElements}
                    noDataMsg={`Forms not found`}
                    prefix = {"googleads"}
                    customClass={'no-border-table'}
                    formName={'table_3'}
                />
                :""}
            </div>                
        </Fragment>
    );
}

export default TableList;